import Button from '@/src/components/Antd/Button/Button';
import EditableTable, {
  BackTitle,
  EditIcon,
} from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EnumMode } from 'src/components/Antd/NumberInput/NumberInput';
import { TableNumberInput } from 'src/components/EditableTable/TableForm/TableForm';
import Err from 'src/components/ErrorNotice/Err';
import ToolTip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Link from 'src/components/Link/Link';
import ProductSelection from 'src/constrains/ProductsSelection/ProductsSelection';
import { onOkCompare } from 'src/constrains/ProductsSelection/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { formatNumber } from 'src/tools/helper';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { ActionType, EnumTablePosition } from 'src/types/common/common';
import { EnumProductType } from 'src/types/common/product';
import { setProductSet } from '../slice';
import { priceCompare } from '../tools';
import { EnumModifiedType } from '../type';
import css from './css.module.less';
import { generateProductSetItem } from './tools';

const ProductSet = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;
  const [visible, setVisible] = React.useState(false);
  const dispatch = useDispatch();
  const productSetItems = useSelector(
    (state: any) => state.productSet.productSetItems,
  );

  const defaultSalePrice = useSelector(
    (state: any) => state.productSet.priceSettings.defaultSalePrice,
  );
  const stockAvailable = props.totalStock || 0;
  const totalPrice = React.useMemo(() => {
    return productSetItems.reduce((pre, now) => {
      const { noOfUnit = 0, unitPrice = 0 } = now;
      return pre + noOfUnit * unitPrice;
    }, 0);
  }, [productSetItems]);
  const productSetItemsEmptyError = useSelector(
    (state: any) => state.productSet.productSetItemsEmptyError,
  );
  const generateUrl = (uuid) => {
    return `/product/simpleProduct/${uuid}`;
  };
  const columns = React.useMemo(() => {
    return [
      {
        title: () => getI18n('general.sKU'),
        key: 'Product',
        childGenerate: (text, record, index) => {
          const { product } = record;
          const { sku } = product || {};
          return (
            <NoWrapContainer>
              <ToolTip title={sku}>{sku}</ToolTip>
            </NoWrapContainer>
          );
        },
        minWidth: 192,
        default: true,
      },
      {
        title: () => getI18n('general.title'),
        key: 'Product',
        childGenerate: (text, record, index) => {
          const { product } = record;
          const { name, uuid } = product || {};
          return (
            <NoWrapContainer>
              <ToolTip title={name}>
                <Link to={generateUrl(uuid)} className={css.productLinkName}>
                  <span>{name}</span>
                </Link>
              </ToolTip>
            </NoWrapContainer>
          );
        },
        minWidth: 500,
        default: true,
      },
      // {
      //   title: () => (
      //     <BackTitle>
      //       <span>Available</span>
      //     </BackTitle>
      //   ),
      //   position: EnumTablePosition.right,
      //   childGenerate: (text, record, index) => {
      //     const { product } = record;
      //     const { stockAvailable } = product;
      //     return (
      //       <NoWrapContainer>
      //         <BackTitle>
      //           <ToolTip title={stockAvailable}>{stockAvailable}</ToolTip>
      //         </BackTitle>
      //       </NoWrapContainer>
      //     );
      //   },
      //   key: 'stock',
      //   minWidth: 198,
      //   default: true,
      // },
      {
        title: () => (
          <BackTitle>
            <EditIcon />
            <span>
              {getI18n(
                'allProducts.addproductset.productSetSelection_No_of_Unit',
              )}
            </span>
          </BackTitle>
        ),
        position: EnumTablePosition.right,
        childGenerate: (text, record, index) => {
          const { noOfUnit, noOfUnitError } = record;
          return (
            <TableNumberInput
              disabled={disabled}
              //suffix='test'
              error={noOfUnitError}
              //rightPosition
              value={noOfUnit}
              onChange={(e) => {
                modifyProductSet({
                  item: {
                    ...record,
                    noOfUnit: e,
                    modifiedType: EnumModifiedType.noOfUnit,
                  },
                  type: ActionType.modify,
                });
              }}
            />
          );
        },
        key: 'noOfUnit',
        minWidth: 127,
        default: true,
      },
      {
        title: () => (
          <BackTitle>
            <EditIcon />
            <span>
              {getI18n(
                'allProducts.addproductset.productSetSelection_Unit_price',
              )}
            </span>
          </BackTitle>
        ),
        position: EnumTablePosition.right,
        childGenerate: (text, record, index) => {
          const { unitPrice, unitPriceError } = record;

          return (
            <TableNumberInput
              disabled={disabled}
              error={unitPriceError}
              //rightPosition
              mode={EnumMode.money}
              value={unitPrice}
              onChange={(e) => {
                modifyProductSet({
                  item: {
                    ...record,
                    unitPrice: e,
                    modifiedType: EnumModifiedType.unitPrice,
                  },
                  type: ActionType.modify,
                });
              }}
            />
          );
        },
        key: 'regionOfOrigin',
        minWidth: 180,
        default: true,
      },
      {
        title: () => (
          <BackTitle>
            <span>
              {getI18n('allProducts.addproductset.productSetSelection_Sum')}
            </span>
          </BackTitle>
        ),
        position: EnumTablePosition.right,
        childGenerate: (text, record, index) => {
          const { unitPrice, noOfUnit } = record;
          return (
            <NoWrapContainer>
              <BackTitle>
                {formatNumber((unitPrice || 0) * (noOfUnit || 0))}
              </BackTitle>
            </NoWrapContainer>
          );
        },
        key: 'Sum',
        minWidth: 190,
        default: true,
      },
    ];
  }, [productSetItems, i18n]);

  const onCancel = () => {
    setVisible(false);
  };
  const onOpen = () => {
    setVisible(true);
  };
  const onOk = (products) => {
    const r = onOkCompare(products, productSetItems, generateProductSetItem);
    dispatch(
      setProductSet({
        type: ActionType.reselect,
        products: r,
      }),
    );
  };
  const selectedItems = React.useMemo(() => {
    if (productSetItems && productSetItems.length) {
      return productSetItems.map((i) => i.product);
    }
  }, [productSetItems]);
  const modifyProductSet = (obj) => {
    dispatch(setProductSet(obj));
  };
  const deleteProductSet = (item) => {
    if (item) {
      dispatch(
        setProductSet({
          type: ActionType.delete,
          item,
        }),
      );
    }
  };

  const defaultSalePriceMismatchError = React.useMemo(() => {
    return !priceCompare(productSetItems, defaultSalePrice);
  }, [productSetItems, defaultSalePrice]);
  return (
    <SectionWrapper
      title={getI18n(
        'allProducts.allProductslist.productlistConfig_add_btn_productset',
      )}
      id={'ProductEditorProductSetSelection'}>
      {visible && (
        <ProductSelection
          visible={visible}
          onCancel={onCancel}
          onOk={onOk}
          selectedItems={selectedItems}
          hideDefaultTypeFilter
          fixedSearchConditions={{
            productTypes: [EnumProductType.Simple],
          }}
          extraProps={{ keepData: true }}
        />
      )}
      <Button
        type='primary'
        className={css.selectionBtn}
        onClick={onOpen}
        disabled={disabled}>
        {getI18n('general.selectProduct')}
      </Button>
      <div className={css.selectionTitle}>
        <div className={css.totalText}>
          {replaceI18nVariables(
            getI18n('allProducts.addproductset.totalstocktotalSets'),
            stockAvailable,
          )}
        </div>
      </div>

      <EditableTable
        disabled={disabled}
        rowKey={'uuid'}
        data={productSetItems}
        columns={columns}
        id='ProductSetEditTable'
        rowDeleteFunc={(index, item) => {
          deleteProductSet(item);
        }}
      />
      <div className={css.sumContainer}>
        {getI18n('allProducts.addproductset.total')}:
        {`${formatNumber(totalPrice)}`}
      </div>
      {defaultSalePriceMismatchError && (
        <div className={css.errContainer}>
          <Err>
            {getI18n('allProducts.addproductset.productSetSelection_err')}
          </Err>
        </div>
      )}
      {productSetItemsEmptyError && (
        <Err>
          {getI18n(
            'allProducts.addVariantProduct.pleaseselectatleastoneproduct',
          )}
        </Err>
      )}
    </SectionWrapper>
  );
};
export default ProductSet;
